import React, { useMemo } from 'react';
import { api } from '../../services/api';
import { FIELD_LABELS } from '../../utils/fieldLabels';
import { parseProjectTagsResponse } from '../../utils/stringComboboxUtils';
import StringCombobox from '../StringCombobox/StringCombobox';

interface ProjectTagComboboxProps {
  value: string;
  onChange: (projectTag: string) => void;
  invalid?: boolean;
  nameInputClassName?: string;
  arrowClassName?: string;
  disabled?: boolean;
}

const ProjectTagCombobox: React.FC<ProjectTagComboboxProps> = ({
  value,
  onChange,
  invalid = false,
  nameInputClassName = '',
  arrowClassName = '',
  disabled = false,
}) => {
  const config = useMemo(
    () => ({
      removedStorageKey: 'removedProjectTags',
      fetchItems: api.expenses.getProjectTags,
      parseItems: parseProjectTagsResponse,
      logLabel: 'project tags',
    }),
    []
  );

  const labels = useMemo(
    () => ({
      fieldLabel: FIELD_LABELS.projectTag,
      openListAriaLabel: 'פתח רשימת תגי פרויקט',
      searchAriaLabel: 'חפש תג פרויקט',
      emptyText: 'לא נמצאו תגי פרויקט',
      noResultsText: 'אין תוצאות',
      removeItemTitle: 'הסר מהרשימה',
      optionIdPrefix: 'project-tag-option',
    }),
    []
  );

  return (
    <StringCombobox
      value={value}
      onChange={onChange}
      config={config}
      labels={labels}
      invalid={invalid}
      nameInputClassName={nameInputClassName}
      arrowClassName={arrowClassName}
      disabled={disabled}
    />
  );
};

export default ProjectTagCombobox;
